<mat-card>
  <mat-card-title>
    {{ '+INVITATIONS.NEW_INVITATION.TITLE' | translate }}
  </mat-card-title>

  <mat-card-content>
    <form [formGroup]="formGroup" class="flex flex-col">
      <div class="inputs-wrapper flex flex-col gap-[32px]">
        <mat-form-field
          mat-input-height-large-label
          class="flex-[100%] max-w-[100%]"
          id="gatewaySerial"
        >
          <mat-label>{{
            '+INVITATIONS.NEW_INVITATION.FORM.GATEWAY_SERIAL.PLACEHOLDER' | translate
          }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="gateway-serial"
            gtmAction="Gateway serial"
            gtmCategory="New invitation form"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            type="text"
            [formControl]="formGroup.controls.gatewaySerial"
            required
            fieldTextContentTooltip
          />
          <mat-error *ngIf="formGroup.controls.gatewaySerial.hasError('required')">
            {{ '+INVITATIONS.NEW_INVITATION.FORM.GATEWAY_SERIAL.REQUIRED' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              formGroup.controls.gatewaySerial.hasError('pattern') &&
              !formGroup.controls.gatewaySerial.hasError('required')
            "
          >
            {{ '+INVITATIONS.NEW_INVITATION.FORM.GATEWAY_SERIAL.INVALID' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              formGroup.controls.gatewaySerial.hasError('minlength') &&
              !formGroup.controls.gatewaySerial.hasError('required')
            "
          >
            {{ '+INVITATIONS.NEW_INVITATION.FORM.GATEWAY_SERIAL.MIN_LENGTH' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]" id="comment">
          <mat-label>{{
            '+INVITATIONS.NEW_INVITATION.FORM.NOTE.PLACEHOLDER' | translate
          }}</mat-label>
          <input
            gtm="onTextField"
            gtmId="comment"
            gtmAction="Comment"
            gtmCategory="New invitation form"
            [gtmOn]="['change', 'focus', 'blur']"
            matInput
            type="text"
            maxlength="100"
            [formControl]="formGroup.controls.comment"
            fieldTextContentTooltip
          />
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-content *ngIf="error?.errorType">
    <vi-alert content>{{ error.errorType | newInvitationError }}</vi-alert>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      id="cancel-btn"
      mat-button
      color="primary"
      gtm="onCancelDialog"
      gtmCategory="newInvitationForm"
      (click)="cancel.emit()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="next-btn"
      mat-raised-button
      color="primary"
      [disabled]="formGroup.invalid"
      gtm="onConfirm"
      gtmAction="Creating new invitation"
      gtmCategory="newInvitationForm"
      (click)="onCreate()"
    >
      {{ 'GENERAL.BUTTON.SUBMIT' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
